import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  blogList: [],
  notificationList: [],
  blogDetail: [],
  blogItemsList: [],
  loading: false,
  error: undefined,
};

const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchBlogList(state, action) {
      state.blogList = action.payload;
      state.loading = false;
    },
    fetchNotificationList(state, action) {
      state.notificationList = action.payload;
      state.loading = false;
    },
    fetchBlogDetail(state, action) {
      state.blogDetail = action.payload;
      state.loading = false;
    },
    fetchBlogStart(state, action) {
      state.blogItemsList = action.payload;
      state.loading = false;
    },
  },
});

export const blogActions = blogSlice.actions;

export default blogSlice.reducer;
